import { logger } from "@/utils/logger"
import { ExecuteCaptcha } from "./executeCaptcha.interface"

export const executeCaptchaMock: ExecuteCaptcha = async (action) => {
  logger.debug("[Action:Started] Executre captcha", { action })
  return [action, null] as const
}
